import { createFileRoute, useParams } from "@tanstack/react-router";
import { EntityTypeFormTab } from "@/features/form-editor/components/entity-type-form-tab";

const ROUTE_ID =
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/assetTypes/$assetTypeId/schema" as const;

export const Route = createFileRoute(ROUTE_ID)({
	component: OrgAssetTypeSchemaTab,
});

function OrgAssetTypeSchemaTab() {
	const { orgId, assetTypeId } = useParams({ from: ROUTE_ID });
	return (
		<EntityTypeFormTab
			entity="asset"
			typeId={assetTypeId}
			scope="org"
			orgId={orgId}
			mutationOrganizationId={orgId}
		/>
	);
}
